import styled from "@emotion/styled";

import type {
  FontSizeProps,
  ColorProps,
  SpaceProps,
  FontWeightProps,
  LineHeightProps,
  ThemeValue,
} from "styled-system";
import {
  space,
  color,
  fontSize,
  fontWeight,
  lineHeight,
  variant,
} from "styled-system";

import type { ExactTheme } from "src/lib/emotion/theme.ts";

interface VariantProps {
  variant?: ThemeValue<"text", ExactTheme>;
}

type Theme = Omit<ExactTheme, "buttons">;

interface TextProps
  extends ColorProps<Theme>,
    SpaceProps<Theme>,
    FontSizeProps<Theme>,
    FontWeightProps<Theme>,
    LineHeightProps<Theme>,
    VariantProps {}

export const Text = styled.span<TextProps>`
  ${variant({
    scale: "text",
  })}
  ${space}
  ${fontSize}
  ${fontWeight}
  ${lineHeight}
  ${color}
`;

Text.defaultProps = {
  variant: "body2",
};
